// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"bafd07d4","453":"ecf512db","732":"0e0d19e4","977":"6af83813"}[chunkId] + ".chunk.js";
};